import { InvoiceWithholding } from "@letsbit/malcolmlb";

export enum INVOICE_LOCAL_PAGE_TYPE {
  INVOICE = "invoice",
  CREDIT_NOTE = "credit_note",
}
export interface InvoiceLocalProps {
  invoice: InvoiceWithholding;
}
